<app-metadata [graphName]="'air-quality-outside'" [displayString]="'Outside Air Quality Metadata'"></app-metadata>
<app-metadata [graphName]="'air-quality-workplace'" [displayString]="'Workplace Air Quality Metadata'"></app-metadata>
<app-metadata [graphName]="'air-quality-radiation'" [displayString]="'Radiation Metadata'"></app-metadata>
@if (sampleInformations && data) {
  <mat-card>
    <mat-card-content>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!(activateSaveButton && hasValidData())"
        (click)="updateData()"
        i18n="save@@save">
      Save
    </button>
      <button
        mat-raised-button
        style="margin-left: 5em"
        color="warn"
        (click)="resetForms()"
        i18n="cancel@@cancel">
      Cancel
    </button>
      @for (info of sampleInformations; track info) {
        <div>
          <div class="row">
            <div class="col">
              <app-forms-sample
                [title]="info['display_' + locale]"
                [sampleCarrier]="data"
                [sampleName]="info.fieldName"
                [helptexts]="helptexts[0]"
                [qualityType]="'air_quality'"
                [qualityEndpoint]="'air-qualities'"
                (formUpdates)="onFormUpdates(info.fieldName, $event)"
              ></app-forms-sample>
            </div>
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
}
